export const HTTP_REQUEST_STARTED = 'HTTP_REQUEST_STARTED';
export const HTTP_REQUEST_FINISHED = 'HTTP_REQUEST_FINISHED';
export const CARD_ANIMATION_ENDED = 'CARD_ANIMATION_ENDED';
export const SHOW_CARD_WITH_ANIMATION = 'SHOW_CARD_WITH_ANIMATION';
export const SHOW_CARD_WITHOUT_ANIMATION = 'SHOW_CARD_WITHOUT_ANIMATION';
